import React, { useState } from "react";
import StudentRemarksModal from "../admin/StudentRemarksModal"; // Adjust path as needed

interface Student {
  studentId: number;
  firstName: string;
  lastName: string;
  email: string;
  whatsappNumber?: string;
}

interface Props {
  students: Student[];
  refreshList?: () => void;
}

const BatchStudents: React.FC<Props> = ({ students, refreshList }) => {
  const [openFor, setOpenFor] = useState<number | null>(null);

  return (
    <div className="mt-4 overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <caption className="sr-only">Batch Students</caption>
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left font-medium text-gray-700">
              Name
            </th>
            <th className="px-4 py-2 text-left font-medium text-gray-700">
              Email
            </th>
            <th className="px-4 py-2 text-left font-medium text-gray-700">
              Mobile
            </th>
            <th className="px-4 py-2 text-left font-medium text-gray-700">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {students.length === 0 ? (
            <tr>
              <td colSpan={4} className="px-4 py-6 text-center text-gray-400">
                No students assigned to this batch.
              </td>
            </tr>
          ) : (
            students.map((student) => (
              <tr key={student.studentId} className="hover:bg-gray-50">
                <td className="px-4 py-2">
                  {student.firstName} {student.lastName}
                </td>
                <td className="px-4 py-2">{student.email}</td>
                <td className="px-4 py-2">{student.whatsappNumber || "—"}</td>
                <td className="px-4 py-2 text-right">
                  <button
                    onClick={() => setOpenFor(student.studentId)}
                    className="px-3 py-1 bg-yellow-400 text-white rounded hover:bg-yellow-500"
                  >
                    Remarks
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {openFor !== null && (
        <StudentRemarksModal
          studentId={openFor}
          onClose={() => setOpenFor(null)}
          refreshList={refreshList ? refreshList : () => {}}
          role="mentor"
        />
      )}
    </div>
  );
};

export default BatchStudents;
